module.exports = __webpack_public_path__ + "img/17862_S.902367d9.png";